import { v4 as uuidv4 } from 'uuid'

export const currencies = [...new Array(5)].map((_: any, index: number) => ({
  id: uuidv4(),
  name: 'Currency ' + ++index,
  __typename: 'Currency'
}))
